<template>
	<Icon v-bind="$props">
		<svg
			width="35"
			height="30"
			viewBox="0 0 35 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				class="light"
				d="M17.5307 0C7.84766 0 0.00171228 6.23437 0.00171228 13.9286C0.00171228 17.252 1.46376 20.2888 3.90302 22.6808C3.04702 26.0538 0.186608 29.0605 0.152368 29.094C-0.00171171 29.2446 -0.0445118 29.4779 0.0496483 29.6788C0.135372 29.8795 0.32513 30 0.54769 30C5.08449 30 8.42974 27.8732 10.176 26.5587C12.4084 27.3817 14.9011 27.8571 17.5307 27.8571C27.2138 27.8571 35 21.6208 35 13.9286C35 6.23638 27.2138 0 17.5307 0Z"
				fill="currentColor"
			/>
			<path
				class="light"
				d="M16.5 5C16.0524 5 15.6923 5.35693 15.6923 5.76699V21.2031C15.6923 21.6447 16.0524 22 16.4697 22C16.887 22 17.3077 21.6447 17.3077 21.2031V5.76699C17.3077 5.35693 16.9476 5 16.5 5ZM13.2692 8.1875C12.8216 8.1875 12.4615 8.54277 12.4615 8.95449V17.9857C12.4615 18.4572 12.8216 18.8125 13.2389 18.8125C13.6563 18.8125 14.0769 18.4572 14.0769 18.0156V8.95449C14.0769 8.54277 13.7168 8.1875 13.2692 8.1875ZM19.7308 9.25C19.2832 9.25 18.9231 9.60527 18.9231 10.017V16.9232C18.9231 17.3947 19.2832 17.75 19.7005 17.75C20.1178 17.75 20.5385 17.3947 20.5385 16.9531V10.017C20.5385 9.60527 20.1784 9.25 19.7308 9.25ZM22.9615 7.125C22.5156 7.125 22.1538 7.48193 22.1538 7.89199V19.0781C22.1538 19.5197 22.5139 19.875 22.9313 19.875C23.4091 19.875 23.7692 19.5197 23.7692 19.0781V7.89199C23.7692 7.48193 23.4091 7.125 22.9615 7.125ZM10.0385 11.375C9.59087 11.375 9.23077 11.7303 9.23077 12.142V14.8281C9.23077 15.2697 9.59087 15.625 10.0082 15.625C10.4255 15.625 10.8462 15.2697 10.8462 14.8281V12.142C10.8462 11.7303 10.4861 11.375 10.0385 11.375ZM6.80769 12.4375C6.36178 12.4375 6 12.7928 6 13.2045V13.7656C6 14.2072 6.36178 14.5625 6.7774 14.5625C7.19303 14.5625 7.61538 14.2072 7.61538 13.7656V13.2045C7.61538 12.7928 7.25361 12.4375 6.80769 12.4375ZM26.1923 12.4375C25.7464 12.4375 25.3846 12.7944 25.3846 13.2045V13.7656C25.3846 14.2072 25.7447 14.5625 26.1923 14.5625C26.6399 14.5625 27 14.2056 27 13.7955V13.2045C27 12.7928 26.6399 12.4375 26.1923 12.4375Z"
				fill="#FFFFFF"
			/>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'AudioMessageIcon',
	components: { Icon },
	props,
}
</script>
<style lang="scss" scoped>
svg path:nth-last-of-type(1) {
	fill: #ffffff;
}
</style>
